import { render, staticRenderFns } from "./AboutMembersIndex4.vue?vue&type=template&id=e63f73b8&"
import script from "./AboutMembersIndex4.vue?vue&type=script&lang=js&"
export * from "./AboutMembersIndex4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports